import React, { useEffect, useState } from "react";
import { Main, Content } from '../../../components/Layout'
import api from '../../../services/api';
import { ChartsBar } from "../../../components/Charts";
import { Col, Row, Table } from 'react-bootstrap';
import Slct from '../../../components/Slct'
import tableStyle from '../../../components/Table/Table.module.css'
import getCommercial from "../../../util/getCommercial";
import { PrintPage } from "../../../components/PrintPage";
import Loading from "../../../components/Loading";
import useWrapper from "../../../hooks/useWrapper";
import TableResponsive from "../../../components/TableResponsive";
import StatusFlag from "../../../components/StatusFlag";

export default function ReportsGroups() {

  const { setbreadcrumb, me, config } = useWrapper();

  const [filter, setFilter] = useState({
    "Tipo": "Cursos"
  })

  const [reports, setReports] = useState({
    data: [],
    title: "",
    type: ""
  });

  const [filterLoading, setfilterLoading] = useState(true);

  const [groups, setgroups] = useState();
  useEffect(() => {
    (async function () {
      const _groups = await getCommercial(null, null, "", "", true);
      setgroups(_groups);
    })()
  }, []);


  useEffect(() => {
    setfilterLoading(true);
    switch (filter["Tipo"]) {
      default:
      case "Cursos":
        api.get("/course/report?report=true&commercials.is_class=1", config)
          .then(response => {
            let responseVar = [...response.data];

            responseVar.sort(function (a, b) {
              return a.commercials.length < b.commercials.length;
            })

            let tableVar = [];
            responseVar.forEach((e, index) => {
              e.commercials.forEach(r => {
                tableVar.push({
                  label: `${e.title} ${r.year}.${r.period} (${r.institution ? r.institution.title : ''})`,
                  type: e.id,
                  "Curso": e.title,
                  color: index + 1,
                  is_class: r.is_class
                })
              })
            })

            setReports({
              data: responseVar.map(e => ({
                label: e.title,
                value: e.commercials.length
              })),
              title: "Turmas por curso",
              type: "turmas",
              table: tableVar
            })
            setfilterLoading(false);
          })
        break;
      case "Instituições":
        api.get("/institution/report?commercials.is_class=1", config)
          .then(response => {
            console.log("instituicoes", response.data)
            let responseVar = [...response.data];
            responseVar.sort(function (a, b) {
              return a.__meta__.total_commercials < b.__meta__.total_commercials;
            })

            let tableVar = [];
            responseVar.forEach((e, index) => {
              e.commercials.forEach(r => {
                tableVar.push({
                  label: `${r.course.title} ${r.year}.${r.period} (${r.institution ? r.institution.title : ''})`,
                  type: e.id,
                  "Curso": e.title,
                  color: index + 1,
                  is_class: r.is_class
                })
              })
            })

            setReports({
              data: responseVar.map(e => ({
                label: e.title,
                value: e.__meta__.total_commercials
              })),
              title: "Turmas por instituição",
              type: "turmas",
              table: tableVar
            })
            setfilterLoading(false);
          })
        break;
      case "Período":
        api.get("/commercial/period/report?is_class=1", config)
          .then(response => {
            let responseVar = [...response.data.data];
            responseVar.sort(function (a, b) {
              return a.period > b.period;
            })

            let tableVar = responseVar.map(e => ({
              label: `${e.course.title} ${e.year}.${e.period} (${e.institution ? e.institution.title : ''})`,
              type: e.period,
              "Período": e.period,
              color: e.period,
              is_class: e.is_class
            }))

            setReports({
              data: [
                { label: "Primeiro Período", value: response.data.periodoUm },
                { label: "Segundo Período", value: response.data.periodoDois }
              ],
              title: "Turmas por período",
              type: "turmas",
              table: tableVar
            })
            setfilterLoading(false);
          })
        break;
      case "Pacotes":
        setReports({
          data: [
            { label: "Em desenvolvimento", value: 1 },
            { label: "Em desenvolvimento", value: 1 }
          ],
          title: "Turmas por pacote",
          type: "turmas"
        })
        setfilterLoading(false);
        break;

      case "Status":
        const _statuses = ["", "Ativa", "Cancelada", "Finalizada"]
        setReports({
          data: [
            { label: "Ativas", value: groups?.filter(__group => __group.status === "Ativa")?.length || 0 },
            { label: "Canceladas", value: groups?.filter(__group => __group.status === "Cancelada")?.length || 0 },
            { label: "Finalizadas", value: groups?.filter(__group => __group.status === "Finalizada")?.length || 0 }
          ],
          title: "Turmas por status",
          type: "turmas",
          table: groups?.map(__group => ({
            label: __group.label,
            type: __group.status,
            "Status": __group.status,
            color: _statuses.indexOf(__group.status) || 0
          }))
        })
        setfilterLoading(false);
        break;
    }
  }, [filter])

  useEffect(() => {
    setbreadcrumb([
      { label: "Relatórios" },
    ])
  }, []);

  return (
    <PrintPage
      has_logo={true}
      signed_by={me.username}
    >
      <Main>
        <Content>
          <Row>
            <Col>
              <div className="d-flex justify-content-between">
                <h2 className="page-title">Relatórios de Turmas</h2>
                <div className="d-flex ml-4">
                  <PrintPage.PrintButton
                    label="Gerar PDF"
                  />
                  <PrintPage.CSVButton
                    label="Gerar CSV"
                    title={reports.title}
                    overview={reports.data}
                    table={reports?.table?.map(_row => ({
                      ...(_row.label !== undefined && { "Turma": _row.label }),
                      ...(_row["Curso"] !== undefined && { "": _row["Curso"] }),
                      ...(_row["Período"] !== undefined && { "": _row["Período"] }),
                      ...(_row["Status"] !== undefined && { "": _row["Status"] }),
                    }))}
                    signed_by={me.username}
                    filter={filter}
                  />
                </div>
              </div>
            </Col>
          </Row>
          <Row className="mt-2 -hide-on-print" style={{ zIndex: 10, position: "relative" }}>
            <Col sm={3}>
              <span className='lince-input_label'>Tipo de Resultados</span>
              <Slct
                className="w-100"
                placeholder="..."
                value={filter["Tipo"]}
                options={[
                  { label: "Instituições", value: "Instituições" },
                  { label: "Cursos", value: "Cursos" },
                  { label: "Período", value: "Período" },
                  { label: "Status", value: "Status" },
                ]}
                onChange={e => {
                  setFilter({
                    ...filter,
                    "Tipo": e.value
                  })
                }}
              />
            </Col>
          </Row>
          {filterLoading ? (
            <Loading className="mt-3" />
          ) : (
            <Row>
              <Col>
                <ChartsBar reports={reports.data} title={reports.title} type={reports.type} />
                {reports.table && (
                  <TableResponsive
                    className="mt-4"
                    table={{
                      head: [
                        { data: "Turma" }
                      ],
                      body: reports?.table?.map(__report => ({
                        data: [
                          { element: <>{__report.label}</> }
                        ],
                        border: `var(--color-cycle-${__report.color})`
                      })) || []
                    }}
                  />
                )}
              </Col>
            </Row>
          )}
        </Content>
      </Main>
    </PrintPage>
  );
}